import * as authService from './authentication.service'
import { getService } from '../../clients/feathers.clients';
import { IBannersFind, IPaymentConfirmationsFin, IProductCategoriesFin, IProductCharacteristics2Fin, IProductCharacteristicsFin, IProductsFind, IRankingsFind, IShippingFin, PropsResGetUsersData } from '../../redux/@types';
import Service from './service.class'

//authenticate
export const authenticationService = authService
//services
export const usersService = new Service<PropsResGetUsersData>(getService('users'))
export const addressesUsersService = new Service<any>(getService('addresses'))
export const productCharacteristicsService = new Service<IProductCharacteristicsFin>(getService('characteristics'))
export const productCategoriesService = new Service<IProductCategoriesFin>(getService('categories'))
export const rankingsService = new Service<IRankingsFind>(getService('reviews'))
export const bannersService = new Service<IBannersFind>(getService('banners'))
export const bannerProductsService = new Service<any>(getService('banner-products'))
export const productsService = new Service<any>(getService('products'))
export const productCharacteristics2Service = new Service<IProductCharacteristics2Fin>(getService('products-characteristics'))
export const ordersService = new Service<any>(getService('orders'))

//TODO: si se implementa el servicio en el backend poner el nombre que le corresponde aquí abajo....
export const taxService = new Service<any>(getService('tax-rule'))
export const systemVariablesService = new Service<any>(getService('configurations'))
export const citiesService = new Service<any>(getService('locations-cities'))
export const statesService = new Service<any>(getService('locations-states'))
export const brandsService = new Service<any>(getService('brands'))
export const discountsService = new Service<any>(getService('discounts'))
export const priceListService = new Service<any>(getService('price-list'))
export const contactsDirectoryService = new Service<any>(getService('contacts-directory'))
export const contactsDirectoryCategories = new Service<any>(getService('contacts-directory-categories'))
export const contactsDirectoryAttributes = new Service<any>(getService('contacts-directory-attributes'))
export const contactsDirectoryMedia = new Service<any>(getService('contacts-directory-media'))
export const walletBonusService = new Service<any>(getService('wallet-bonus'))
export const walletMovementsService = new Service<any>(getService('wallet-movements'))
export const coursesCategoriesService = new Service<any>(getService('courses-categories'))
export const coursesService = new Service<any>(getService('courses'))
export const courseSectionsService = new Service<any>(getService('course-sections'))
export const courseChaptersService = new Service<any>(getService('course-chapters'))
export const courseBenefitsService = new Service<any>(getService('course-benefits'))
export const cMSService = new Service<any>(getService('cms'))
export const workOffersCategoriesService = new Service<any>(getService('work-offers-categories'))
export const workOffersService = new Service<any>(getService('work-offers'))
export const fulfillmentCompanyService = new Service<any>(getService('fulfillment-company'))
export const fulfillmentCitiesService = new Service<any>(getService('fulfillment-cities'))
export const fulfillmentMatrixService = new Service<any>(getService('fulfillment-matrix'))
export const listCustomerGroupsService = new Service<any>(getService('customer-group'))
export const listCustomersService = new Service<any>(getService('customer-group-customers'))
export const priceListsService = new Service<any>(getService('price-list'))
export const configurationCashbackService = new Service<any>(getService('configuration-cashback'))
export const recipesCategoriesService = new Service<any>(getService('recipes-categories'))
export const recipesService = new Service<any>(getService('recipes'))
export const productsRecipesService = new Service<any>(getService('products-recipes'))
export const productsPremiumCharacteristicsService = new Service<any>(getService('products-premium-characteristics'))
export const productsPremiumPreparationsStepsService = new Service<any>(getService('products-premium-preparation-steps'))
export const storesService = new Service<any>(getService('stores'))

export const siesaIntegrationLogsService = new Service<any>(getService('siesa-integration-logs'))
export const siesaIntegrationQueueService = new Service<any>(getService('siesa-integration-queue'))



export const shippingService = new Service<any>(getService('shipping'))
export const shippingQuantityService = new Service<any>(getService('shipping-details'))
export const ordersDetailsService = new Service<any>(getService('orders-details'))
export const paymentConfirmationsService = new Service<IPaymentConfirmationsFin>(getService('payment-confirmations'))
export const taxRuleService = new Service<any>(getService('tax-rule'))
export const productMediaService = new Service<any>(getService('products-media'))
export const orderStatusService = new Service<any>(getService('orders-status'))
//s3 SERVICES
export const s3FileUploadService = new Service(getService('s3Client'))
// export const usersService = app.service('users')
